import  request  from '../../Interceptor/request.js'

//缴费记录查询
export function records(data) {
    return request({
        url: '/order/listOwners',
        method: 'get',
        params:data
    })
}
